"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PostStatus;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./_post-status.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function PostStatus(_ref) {
  var status = _ref.status;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('post-status', {
      'post-status__published': status === 'PUBLISHED'
    })
  }, _react.default.createElement("h3", {
    className: "post-status__text"
  }, status));
}